import { put, call, all } from 'redux-saga/effects';

import watch from 'common/sagas/watch';
import { actions as errorActions } from 'error';
import { api } from 'app/services';
import actions from '../actions';

function* fetchRewards() {
  const { response, error } = yield call(api.fetchRewards);

  if (response) yield put(actions.rewardsSuccess(response));
  else {
    yield all([
      put(actions.rewardsFailure(error)),
      put(errorActions.apiError(error)),
    ]);
  }
}

function* fetchRewardDetails({ unlockingDate }) {
  const { response, error } = yield call(
    api.fetchRewardDetails,
    unlockingDate
  );

  if (response) yield put(actions.rewardDetailsSuccess(response));
  else {
    yield all([
      put(actions.rewardDetailsFailure(error)),
      put(errorActions.apiError(error)),
    ]);
  }
}

function* fetchWithdrawals() {
  const { response, error } = yield call(api.fetchWithdrawals);

  if (response) yield put(actions.withdrawalsSuccess(response));
  else {
    yield all([
      put(actions.withdrawalsFailure(error)),
      put(errorActions.apiError(error)),
    ]);
  }
}

export default function* root() {
  yield watch(actions.rewardsRequest, fetchRewards);
  yield watch(actions.rewardDetailsRequest, fetchRewardDetails);
  yield watch(actions.withdrawalsRequest, fetchWithdrawals);
}

